export default "__VITE_ASSET__Mn6JbxGm__"